var app = angular
    .module('inspecciones')
    .factory('inspeccionesService', ['$http', '$q', '__env', '$routeParams', function inspeccionesService($http, $q, __env, $routeParams) {
        var serviceUrl = __env.apiUrl;
        var inspeccionesTunelADIFUrl = 'inspeccionesTunelADIF';
        var inspeccionesPresaUrl = 'inspeccionesPresa';
        var inspeccionesTunelUrl = 'inspeccionesTunel';
        var dañosADIFUrl = 'damagesADIF';
        var dañosUrl = 'damages';
        var tunelUrl = 'tuneles';
        var presaUrl = 'presas';
        var categoriasUrl = 'categorias';


        function getInspeccionesTunelADIF(idTunelADIF) {
            return $http.get(serviceUrl + inspeccionesTunelADIFUrl + '/tunelADIF/' + idTunelADIF);
        }


        function getDWGTunelADIF(idInspeccion, strRutaArchivo) {

            var ruta = strRutaArchivo
                .split('/')
                .map(encodeURIComponent)
                .join('/');

            return $http({
                method: 'GET',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/visor-dxf/' + idInspeccion + '/' + ruta,
                responseType: 'blob' // Importante para manejar imágenes
            });
        }

        function getInspeccionesPresa(idPresa) {
            return $http.get(serviceUrl + inspeccionesPresaUrl + '/presa/' + idPresa);
        }

        function getDaños(idInspeccion) {
            return $http({
                method: 'get',
                url: serviceUrl + dañosADIFUrl + "/inspeccion/" + idInspeccion,
            });
        }

        function getDañosADIF(idInspeccion) {
            return $http({
                method: 'get',
                url: serviceUrl + dañosADIFUrl + "/inspeccion/" + idInspeccion,
            });
        }

        function calculainspeccionanteriorTunel(idTunelADIF) {
            return $http.get(serviceUrl + inspeccionesTunelADIFUrl + "/fechaanterior/" + idTunelADIF);
        }

        function calculainspeccionanteriorPresa(idPresa) {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/fechaanterior/" + idPresa);
        }

        function getDañosPorTipo(idInspeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesportipogravedad/" + idInspeccion);
        }

        function getReparaciones(idInspeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/reparacionesportipogravedad/" + idInspeccion);
        }

        function getDañosPorPK(idInspeccion, distSeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesporpkgravedad/" + idInspeccion + '/' + distSeccion);
        }

        function getDañosPorElemento(idInspeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesporelementogravedad/" + idInspeccion);
        }

        function getDaño(idDañoADIF) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damageInspeccion/" + idDañoADIF);
        }

        function getInspeccionTunel(idInspeccion) {
            return $http.get(serviceUrl + inspeccionesTunelUrl + "/inspeccion/" + idInspeccion);
        }

        function getInspeccionTunelADIF(idInspeccion) {
            return $http.get(serviceUrl + inspeccionesTunelADIFUrl + "/inspeccion/" + idInspeccion);
        }

        function getInspeccionPresa(idInspeccion) {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/inspeccion/" + idInspeccion);
        }

        function getSecciones(idInspeccion, distancia) {
            return $http.get(serviceUrl + dañosADIFUrl + "/secciones/" + idInspeccion + "/" + distancia);
        }

        function getDañosPorCodigo(idDaño) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damageCodigo/" + idDaño);
        }

        function getDañoPorCodigo(idDañoADIF) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damageCodigo/" + idDañoADIF);
        }

        function getDañosCompletosPorCodigo(idDañoADIF) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damageCodigoCompleto/" + idDañoADIF);
        }

        function getEvoluciones() {
            return $http.get(serviceUrl + categoriasUrl + "/evoluciones/");
        }

        function getGravedades() {
            return $http.get(serviceUrl + categoriasUrl + "/gravedades/");
        }

        function getTipologiasPresa() {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/tipologiadamage/");
        }

        function getTiposDañoPresa() {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/codigodaño/");
        }

        function getElementosPresa() {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/elemento/");
        }

        function getIntensidadesPresa() {
            return $http.get(serviceUrl + inspeccionesPresaUrl + "/intensidad/");
        }



        function crearInspeccionTunel(tunelId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelUrl + '/crear/',
                params:
                {
                    'tunelId': tunelId
                }
            });
        }


        function crearInspeccionTunelADIF(tunelADIFId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/crear/',
                params:
                {
                    'tunelADIFId': tunelADIFId
                }
            });
        }


        function crearInspeccionPresa(presaId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/crear/',
                params:
                {
                    'tunelId': presaId
                }
            });
        }


        function putInspeccionTunel(inspeccion) {
            //return $http.put(serviceUrl + inspeccionsUrl + '/put/');

            return $http({
                method: 'put',
                url: serviceUrl + inspeccionesTunelUrl + '/put/',
                params:
                {
                    'strInspeccion': JSON.stringify(inspeccion)
                },
            });
        }


        function putInspeccionTunelADIF(inspeccion) {
            //return $http.put(serviceUrl + inspeccionsUrl + '/put/');

            return $http({
                method: 'put',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/put/',
                params:
                {
                    'strInspeccion': JSON.stringify(inspeccion)
                },
            });
        }

        function putInspeccionPresa(inspeccion) {
            //return $http.put(serviceUrl + inspeccionsUrl + '/put/');

            return $http({
                method: 'put',
                url: serviceUrl + inspeccionesPresaUrl + '/put/',
                params:
                {
                    'strInspeccion': JSON.stringify(inspeccion)
                },
            });
        }


        function verInspeccionTunel(path, nombre) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/',
                params:
                {
                    'parte': path + '/' + nombre,
                }
            });
        }

        function verInspeccionPresa(path, nombre) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/',
                params:
                {
                    'parte': path + '/' + nombre,
                }
            });
        }


        function modificarInspeccionTunel(path, nombre) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/',
                params:
                {
                    'parte': path + '/' + nombre,
                }
            });
        }

        function modificarInspeccionPresa(path, nombre) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/',
                params:
                {
                    'parte': path + '/' + nombre,
                }
            });
        }


        function eliminarInspeccionTunel(inspeccionId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelUrl + '/eliminarInspeccion/' + inspeccionId
            });
        }

        function eliminarInspeccionTunelADIF(inspeccionId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/eliminarInspeccion/' + inspeccionId
            });
        }

        function eliminarInspeccionPresa(inspeccionId) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/eliminarInspeccion/' + inspeccionId
            });
        }


        function eliminarDamage(idDañoADIF) {
            return $http({
                method: 'post',
                url: serviceUrl + dañosADIFUrl + '/eliminarDamage/' + idDañoADIF
            });
        }

        function eliminarDañoPresa(idDaño) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/eliminarDamage/' + idDaño
            });
        }

        function getTunelId(infraestructuraId) {
            return $http.get(serviceUrl + tunelUrl + "/infraestructura/" + infraestructuraId);
        }

        function getPresaId(infraestructuraId) {
            return $http.get(serviceUrl + presaUrl + "/infraestructura/" + infraestructuraId);
        }

        function getDañosPorSeccion(idInspeccion, distSeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesporseccion/" + idInspeccion + "/" + distSeccion);
        }

        function getDañosPorPosicion(idInspeccion, distSeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesporposicion/" + idInspeccion + "/" + distSeccion);
        }

        function getDañosPorSeccionPosicion(idInspeccion, seccion, distSeccion) {
            return $http.get(serviceUrl + dañosADIFUrl + "/damagesporseccionposicion/" + idInspeccion + "/" + seccion + "/" + distSeccion);
        }

        function getCategoriasDaño() {
            return $http.get(serviceUrl + dañosADIFUrl + '/categoriasdano/');
        }

        function getUltimaInspeccionTunel(idTunelADIF) {
            return $http.get(serviceUrl + tunelADIFUrl + '/last/' + idTunelADIF);
        }

        function getUltimaInspeccionPresa(idPresa) {
            return $http.get(serviceUrl + presaUrl + '/last/' + idPresa);
        }

        function guardarDaño(damage) {
            return $http({
                method: 'post',
                url: serviceUrl + dañosADIFUrl + '/guardardamage/',
                params:
                {
                    'strDañoNube': damage
                }
            });
        }

        function guardarDañoPresa(tipologia, dano, elemento, intensidad, inspeccion) {
            return $http({
                method: 'post',
                url: serviceUrl + inspeccionesPresaUrl + '/guardardamage/',
                params:
                {
                    'tipologia': tipologia,
                    'dano': dano,
                    'elemento': elemento,
                    'intensidad': intensidad,
                    'inspeccion': inspeccion
                }
            });
        }

        function getImagen(idDaño) {
            return $http({
                method: 'GET',
                url: serviceUrl + dañosADIFUrl + '/getimagen/' + idDaño,
                responseType: 'blob' // Importante para manejar imágenes
            });
        }


        function getdamagesporInspeccion(inspeccion) {
            return $http.get(serviceUrl + inspeccionesPresaUrl + '/damagePorInspeccion/' + inspeccion);
        }

        function actualizarEscenario(inspeccion) {
            return $http.post(serviceUrl + inspeccionesPresaUrl + '/actualizarEscenario/' + inspeccion);
        }


        function exportarDanosInspeccionExcel(idInspeccion) {
            return $http({
                method: 'GET',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/' + idInspeccion + '/danos/exportar',
                responseType: 'arraybuffer'
            });
        }

        function getAdjuntos(idInspeccion) {
            return $http.get(serviceUrl + inspeccionesTunelADIFUrl + '/' + idInspeccion + '/adjuntos');
        }


        function subirAdjuntos(idInspeccion, archivos) {

            var formData = new FormData();


            angular.forEach(
                archivos,
                function (archivo) {

                    formData.append(
                        'archivo',
                        archivo
                    );

                }
            );


            return $http({
                method: 'POST',

                url: serviceUrl + inspeccionesTunelADIFUrl + '/' + idInspeccion + '/adjuntos',
                data: formData,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type':
                        undefined
                }
            });
        }


        function descargarAdjunto(idInspeccion, nombre) {

            return $http({
                method: 'GET',

                url: serviceUrl + inspeccionesTunelADIFUrl + '/' + idInspeccion + '/adjuntos/descargar',

                params: {
                    nombre:
                        nombre
                },

                responseType:
                    'arraybuffer'
            });
        }


        function eliminarAdjunto(idInspeccion, nombre) {

            return $http({
                method: 'DELETE',
                url: serviceUrl + inspeccionesTunelADIFUrl + '/' + idInspeccion + '/adjuntos',
                params: {
                    nombre:
                        nombre
                }
            });
        }


        return {

            getInspeccionesTunelADIF: getInspeccionesTunelADIF,
            getDWGTunelADIF: getDWGTunelADIF,
            getInspeccionesPresa: getInspeccionesPresa,
            eliminarInspeccionTunel: eliminarInspeccionTunel,
            eliminarInspeccionTunelADIF: eliminarInspeccionTunelADIF,
            eliminarInspeccionPresa: eliminarInspeccionPresa,
            modificarInspeccionTunel: modificarInspeccionTunel,
            modificarInspeccionPresa: modificarInspeccionPresa,
            verInspeccionTunel: verInspeccionTunel,
            verInspeccionPresa: verInspeccionPresa,
            putInspeccionTunel: putInspeccionTunel,
            putInspeccionTunelADIF: putInspeccionTunelADIF,
            putInspeccionPresa: putInspeccionPresa,
            getInspeccionTunel: getInspeccionTunel,
            getInspeccionPresa: getInspeccionPresa,
            getDaño: getDaño,
            getDaños: getDaños,
            getDañosPorTipo: getDañosPorTipo,
            getDañosPorElemento: getDañosPorElemento,
            calculainspeccionanteriorTunel: calculainspeccionanteriorTunel,
            calculainspeccionanteriorPresa: calculainspeccionanteriorPresa,
            eliminarDamage: eliminarDamage,
            eliminarDañoPresa: eliminarDañoPresa,
            getDañosPorPK: getDañosPorPK,
            getTunelId: getTunelId,
            getPresaId: getPresaId,
            getDañosPorSeccion: getDañosPorSeccion,
            getDañosPorPosicion: getDañosPorPosicion,
            getDañosPorSeccionPosicion: getDañosPorSeccionPosicion,
            getdamagesporInspeccion: getdamagesporInspeccion,
            getSecciones: getSecciones,
            getCategoriasDaño: getCategoriasDaño,
            guardarDaño: guardarDaño,
            guardarDañoPresa: guardarDañoPresa,
            getUltimaInspeccionTunel: getUltimaInspeccionTunel,
            getUltimaInspeccionPresa: getUltimaInspeccionPresa,
            getImagen: getImagen,
            getReparaciones: getReparaciones,
            getDañosPorCodigo: getDañosPorCodigo,
            getEvoluciones: getEvoluciones,
            getGravedades: getGravedades,
            getTipologiasPresa: getTipologiasPresa,
            getTiposDañoPresa: getTiposDañoPresa,
            getElementosPresa: getElementosPresa,
            getIntensidadesPresa: getIntensidadesPresa,
            getDañosCompletosPorCodigo: getDañosCompletosPorCodigo,
            crearInspeccionTunel: crearInspeccionTunel,
            crearInspeccionTunelADIF: crearInspeccionTunelADIF,
            crearInspeccionPresa: crearInspeccionPresa,
            actualizarEscenario: actualizarEscenario,
            getDañosADIF: getDañosADIF,
            getInspeccionTunelADIF: getInspeccionTunelADIF,
            exportarDanosInspeccionExcel: exportarDanosInspeccionExcel,
            getAdjuntos: getAdjuntos,
            subirAdjuntos: subirAdjuntos,
            descargarAdjunto: descargarAdjunto,
            eliminarAdjunto: eliminarAdjunto,
        }
    }]);